
import { mapGetters, mapActions } from 'vuex'
import reviewData from '@/data/reviews.json'

export default {
  data: () => ({
    reviews: reviewData
  }),

  computed: {
    ...mapGetters({
      activeModal:    'pages/getActiveModal',
      regionClicked:  'cart/getRegionClicked',
    }),
  },

  watch: {
    '$route'() {
      this.$store.commit('cart/hideAdded')
    }
  },

  mounted() {
    this.$store.commit('cart/hideAdded')
    this.$nextTick(async function () {
      this.hideModal()

      if (window) {
        // Init Front Chat
        // if (window.FrontChat && typeof window.FrontChat === 'function') {
        //   window.FrontChat('init', { chatId: '47c2e4a291225d5ff81f6f4e52b634c4', useDefaultLauncher: true });
        // }

        // Fetch profile data if logged in but email not yet in store (persisted session)
        if (this.$store.state.user.isLoggedIn) {
          await this.$store.dispatch('user/ensureProfileData', this.$axios)
        }

        // Fetch profile data if logged in but email not yet in store (persisted session)
        // if (this.$store.state.user.isLoggedIn) {
        //   await this.$store.dispatch('user/ensureProfileData', this.$axios)
        // }

        // Page interest tracking
        if (window.location.href.includes("teach-english-abroad")) {
          this.$gtm.push({ 'event': 'interested_in', 'interest': 'Interested in TEA' });
        }
        if (window.location.href.includes("teach-english-online")) {
          this.$gtm.push({ 'event': 'interested_in', 'interest': 'Interested in TEO' });
        }

        // Push userId and user_data to dataLayer for Enhanced Conversions
        const user = this.$store.state.user
        if (user && user.user_id !== '') {
          this.$gtm.push({ userId: user.user_id })
        }
        if (user && user.email) {
          this.$gtm.push({
            user_data: {
              email:      user.email,
              first_name: user.first_name || '',
              last_name:  user.last_name  || ''
            }
          })
        }

        if (window.location.href.includes("teach-english-in-")) {
          const substring = "teach-english-in-"
          const pathArray = window.location.pathname.split('/');
          const index = pathArray.findIndex(el => el.includes(substring));
          if (index !== -1) {
            const country = pathArray[index]
              .replace('teach-english-in-', '')
              .replaceAll('-', ' ');
            const countryCapitalised = country.charAt(0).toUpperCase() + country.slice(1);
            this.$gtm.push({ 'event': 'interested_in', 'interest': 'Interested in ' + countryCapitalised });
          }
        }

        // Capture all click IDs, campaign params, and touchpoint journey for this visit.
        // addTouchpoint must run last so click IDs are already stored when it fires.
        this.addTeflId();
        this.addGclid();
        this.addBraid();
        this.addFbclid();
        this.addTtclid();
        this.addMsclkid();
        this.addWebgains();
        this.addTouchpoint();
      }
    })
  },

  methods: {
    ...mapActions({
      updateActiveModal: 'pages/updateActiveModal',
    }),

    hideModal() {
      this.updateActiveModal(null)
    },

    // Returns a storage record with the value and an expiry timestamp.
    // Default is 30 days — override per platform to match their attribution windows.
    getExpiryRecord(value, expiryMs = 30 * 24 * 60 * 60 * 1000) {
      return {
        value,
        expiryDate: new Date().getTime() + expiryMs
      };
    },

    // Reads a single query param from the current URL
    getParam(p) {
      const match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
      return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    },

    // Reads a stored click ID record from localStorage and checks it hasn't expired.
    // Cleans up the record if it has expired or is malformed.
    getStoredClickId(key) {
      try {
        const stored = JSON.parse(localStorage.getItem(key));
        if (stored && new Date().getTime() < stored.expiryDate) {
          return stored;
        }
        if (stored) localStorage.removeItem(key);
      } catch (e) {
        localStorage.removeItem(key);
      }
      return null;
    },

    addTeflId() {
      const teflID = this.getParam('teflid') || this.getParam('utm_tefl');
      if (teflID) {
        // Last-touch: always overwrite with latest value.
        localStorage.setItem('tefl_teflid', teflID);
        console.log('TeflID captured:', teflID);
      }
    },

    addGclid() {
      const gclidParam  = this.getParam('gclid');
      const gclsrcParam = this.getParam('gclsrc');

      // gclsrc must be absent or contain 'aw' (Google Ads) — ignores DoubleClick etc.
      const isGclsrcValid = !gclsrcParam || gclsrcParam.includes('aw');

      if (gclidParam && isGclsrcValid) {
        // 30-day expiry — matches Google Ads default attribution window.
        localStorage.setItem('gclid', JSON.stringify(this.getExpiryRecord(gclidParam)));
        console.log('GCLID captured:', gclidParam);
      }
    },

    // Google's iOS/ATT alternatives to gclid. Same 30-day window as gclid, so a
    // checkout days later can still read them.
    addBraid() {
      const gbraidParam = this.getParam('gbraid');
      const wbraidParam = this.getParam('wbraid');
      if (gbraidParam) {
        localStorage.setItem('gbraid', JSON.stringify(this.getExpiryRecord(gbraidParam)));
        console.log('GBRAID captured:', gbraidParam);
      }
      if (wbraidParam) {
        localStorage.setItem('wbraid', JSON.stringify(this.getExpiryRecord(wbraidParam)));
        console.log('WBRAID captured:', wbraidParam);
      }
    },

    addFbclid() {
      const fbclidParam = this.getParam('fbclid');
      if (fbclidParam) {
        // 7-day expiry — matches Meta's default attribution window.
        const sevenDays = 7 * 24 * 60 * 60 * 1000;
        localStorage.setItem('fbclid', JSON.stringify(this.getExpiryRecord(fbclidParam, sevenDays)));
        console.log('FBCLID captured:', fbclidParam);
      }
    },

    addTtclid() {
      const ttclidParam = this.getParam('ttclid');
      if (ttclidParam) {
        // 7-day expiry — matches TikTok's default attribution window.
        const sevenDays = 7 * 24 * 60 * 60 * 1000;
        localStorage.setItem('ttclid', JSON.stringify(this.getExpiryRecord(ttclidParam, sevenDays)));
        console.log('TTCLID captured:', ttclidParam);
      }
    },

    addMsclkid() {
      // Microsoft Ads (Bing) auto-tagging click ID — msclkid appears on the URL
      // when auto-tagging is enabled in Microsoft Advertising.
      // 30-day expiry — matches the Microsoft Advertising default conversion window.
      const msclkidParam = this.getParam('msclkid');
      if (msclkidParam) {
        localStorage.setItem('msclkid', JSON.stringify(this.getExpiryRecord(msclkidParam)));
        console.log('MSCLKID captured:', msclkidParam);
      }
    },

    addWebgains() {
      const wguParam      = this.getParam('wgu');
      const wgexpiryParam = this.getParam('wgexpiry');
      const siteidParam   = this.getParam('siteid');

      if (wguParam) {
        // wgexpiry is a Unix timestamp in seconds from Webgains — convert to ms.
        const expiryDate = wgexpiryParam
          ? parseInt(wgexpiryParam) * 1000
          : new Date().getTime() + (30 * 24 * 60 * 60 * 1000);

        const wgRecord = { value: wguParam, expiryDate, siteid: siteidParam || null };
        localStorage.setItem('wg_s2s', JSON.stringify(wgRecord));

        const expiryDays = Math.ceil((expiryDate - new Date().getTime()) / (24 * 60 * 60 * 1000));
        this.$cookies.set('wg_s2s', wguParam, { expires: expiryDays + 'd' });
        console.log('Webgains tracking captured:', wgRecord);
      }

      // Clean up expired Webgains record if present
      try {
        const stored = JSON.parse(localStorage.getItem('wg_s2s'));
        if (stored && new Date().getTime() >= stored.expiryDate) {
          localStorage.removeItem('wg_s2s');
          this.$cookies.remove('wg_s2s');
          console.log('Webgains tracking expired, removed from storage');
        }
      } catch (e) {
        localStorage.removeItem('wg_s2s');
      }
    },

    addTouchpoint() {
      const now       = new Date().getTime();
      const maxPoints = 20;
      // Retain generously — the dashboard applies shorter analysis windows on top.
      // Confirm against the real time-to-conversion tail once the Journeys tab is live.
      const maxAgeMs  = 365 * 24 * 60 * 60 * 1000;
      const referrer  = document.referrer;
      const url       = window.location.pathname;

      const utmSource   = this.getParam('utm_source');
      const utmMedium   = this.getParam('utm_medium');
      const utmCampaign = this.getParam('utm_campaign');
      const utmContent  = this.getParam('utm_content');
      const utmTerm     = this.getParam('utm_term');

      

      // Click IDs from this specific visit's URL — not read from storage,
      // so we know exactly which touchpoints had active ad clicks
      const gclid   = this.getParam('gclid')   || null;
      // Google sends gbraid/wbraid INSTEAD of gclid on iOS under ATT. Without these
      // an auto-tagged iOS click has no paid signal — and if the in-app browser also
      // strips the referrer, the visit is not recorded at all.
      const gbraid  = this.getParam('gbraid')  || null;
      const wbraid  = this.getParam('wbraid')  || null;
      const fbclid  = this.getParam('fbclid')  || null;
      const ttclid  = this.getParam('ttclid')  || null;
      const msclkid = this.getParam('msclkid') || null;
      const teflid  = this.getParam('teflid')  || null;
      const wg      = this.getParam('wgu')     || null;
      const hasClickId = gclid || fbclid || ttclid || msclkid || teflid || wg || gbraid || wbraid;

      // Determine if this is a referral visit (external referrer, not our own domain)
      const isReferral = referrer &&
        !referrer.includes(window.location.hostname) &&
        !referrer.includes('tefl.org') &&
        !referrer.includes('localhost');

      // Payment provider returns (Klarna, Clearpay, etc) are mid-checkout bounces
      // back to our site, not marketing touches — don't record them
      const paymentHosts = ['klarna.', 'clearpay.', 'afterpay.', 'stripe.', 'paypal.',
      'payments.amazon.', 'scalapay.', 'zip.co', 'quadpay.', 'affirm.', 'sezzle.',
      'laybuy.', 'mollie.', 'adyen.', 'worldpay.', 'checkout.com', 'revolut.'];

      if (isReferral && !hasClickId && paymentHosts.some(h => referrer.includes(h))) return;

      // Record if this visit has UTM params, a click ID, OR an external referrer.
      // Previously click-ID-only visits were dropped — e.g. Meta's in-app browser
      // often strips the referrer, and Google Ads auto-tagging carries no UTMs.
      const hasUtms = utmSource || utmMedium || utmCampaign;
      if (!hasUtms && !isReferral && !hasClickId) return;

      // Build the touchpoint
      const touchpoint = {
        timestamp: now,
        url,
        referrer:  referrer || null,
        source:    utmSource   || (isReferral ? 'referral' : null),
        medium:    utmMedium   || (isReferral ? 'referral' : null),
        campaign:  utmCampaign || null,
        content:   utmContent  || null,
        term:      utmTerm     || null,
        // Click IDs from this visit
        gclid,
        gbraid,
        wbraid,
        fbclid,
        ttclid,
        msclkid,
        teflid,
        wg,
      };

      let touchpoints = [];
      try {
        touchpoints = JSON.parse(localStorage.getItem('tefl_touchpoints')) || [];
      } catch (e) {
        touchpoints = [];
      }
      // Prune touches older than the window, but never drop index 0 — the true
      // first touch is the most valuable record for first-vs-last analysis, and
      // on a long sales cycle it's often older than the window itself.
      touchpoints = touchpoints.filter((tp, i) => i === 0 || (now - tp.timestamp) < maxAgeMs);

      // Skip if this looks like a duplicate — same source/medium/campaign AND same
      // click IDs recorded within the last 30 minutes. Page refreshes keep the
      // query string, so click IDs must match too or a refresh would re-record;
      // equally, a genuinely fresh ad click (new gclid) always records even if
      // the UTMs look identical.
      const thirtyMins = 30 * 60 * 1000;
      const last = touchpoints[touchpoints.length - 1];
      const sameClickIds = last &&
        (last.gclid   || null) === gclid &&
        (last.gbraid  || null) === gbraid &&
        (last.wbraid  || null) === wbraid &&
        (last.fbclid  || null) === fbclid &&
        (last.ttclid  || null) === ttclid &&
        (last.msclkid || null) === msclkid &&
        (last.teflid  || null) === teflid;
      const isDuplicate = last &&
        sameClickIds &&
        last.source   === touchpoint.source &&
        last.medium   === touchpoint.medium &&
        last.campaign === touchpoint.campaign &&
        (now - last.timestamp) < thirtyMins;

      if (isDuplicate) return;

      // Append, capping at maxPoints — but pin the true first touch so the
      // journey's origin is never silently discarded
      touchpoints.push(touchpoint);
      if (touchpoints.length > maxPoints) {
        touchpoints = [touchpoints[0]].concat(touchpoints.slice(-(maxPoints - 1)));
      }

      localStorage.setItem('tefl_touchpoints', JSON.stringify(touchpoints));
      console.log('Touchpoint recorded:', touchpoint);
      console.log('Journey so far:', touchpoints.length, 'touchpoints');
    },
  },
}
